import { Link } from "react-router-dom";
import PricingSection from "../components/PricingSection";
import ObjectionFAQ from "../components/ObjectionFAQ";
import { FounderSection, ProofSection } from "../components/TrustSections";
import { btnPrimary } from "../components/CtaLink";
import { Search, CalendarCheck, Bot } from "lucide-react";
import site from "../content/site.json";

const ICONS = [Search, CalendarCheck, Bot];

export default function Pricing() {
  return (
    <div>
      <section className="bg-slate-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">Three products. One outcome.</h1>
          <p className="mt-4 text-slate-300 max-w-2xl mx-auto">Get Found. Get Chosen. Get Paid. Start where your business is today — each plan builds on the last.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <PricingSection />
        <div className="text-center mt-12">
          <p className="text-slate-500">Not sure? Scan your website and we'll recommend the appropriate level automatically.</p>
          <Link to="/free-scan" className={`${btnPrimary} mt-4`} data-testid="pricing-page-scan">Scan Free</Link>
          <p className="mt-4 text-sm text-slate-500">
            <Link to="/sample-report" className="text-indigo-600 font-semibold hover:underline" data-testid="pricing-sample-report-link">See a sample report</Link>
            <span className="mx-2">·</span>
            <Link to="/demos" className="text-indigo-600 font-semibold hover:underline" data-testid="pricing-demos-link">Watch industry demonstrations</Link>
            <span className="mx-2">·</span>
            <Link to="/ai-visibility-vs-ai-transactions" className="text-indigo-600 font-semibold hover:underline" data-testid="pricing-visibility-link">What we can and can't promise</Link>
          </p>
        </div>
        <div className="mt-20" data-testid="pricing-scenarios">
          <div className="text-center max-w-2xl mx-auto">
            <p className="font-mono text-xs uppercase tracking-widest text-indigo-600 mb-3">Which level is right for you?</p>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Real situations, in plain English.</h2>
            <p className="mt-3 text-slate-500">Find the sentence that sounds like you — that's your starting point.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-10">
            {site.scenarios.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <div key={s.tier} className="rounded-2xl border border-slate-200 bg-white p-7 flex flex-col">
                  <div className="flex items-center gap-3">
                    <div className="h-11 w-11 rounded-xl bg-indigo-50 flex items-center justify-center shrink-0"><Icon className="h-5 w-5 text-indigo-600" /></div>
                    <div><p className="font-heading font-bold text-slate-900 leading-tight">{s.tier}</p><p className="text-xs text-slate-400">{s.who}</p></div>
                  </div>
                  <p className="mt-5 text-sm italic text-slate-700 border-l-2 border-indigo-200 pl-3">"{s.quote}"</p>
                  <p className="mt-4 text-sm text-slate-600 leading-relaxed">{s.what}</p>
                  <div className="rounded-xl bg-emerald-50 border border-emerald-100 px-4 py-3 mt-auto pt-3">
                    <p className="text-[11px] font-semibold uppercase tracking-wide text-emerald-700">The result</p>
                    <p className="text-sm text-emerald-800 mt-1 leading-relaxed">{s.result}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <FounderSection />
      <ProofSection />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20"><ObjectionFAQ /></section>
    </div>
  );
}
